import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestTermsPut = {
    path: "/terms/:id",
    method: RouteHttpVerb.PUT
};
export { locationRestTermsPut };
